"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caselle-landi": {
    "1809ca8d": [{
      "hkey": "8aed549c",
      "slug": "caselle-landi",
      "name": "Caselle Landi",
      "primary": true,
      "skipSearch": false
    }],
    "mazzanino": [{
      "hkey": "8aed549c",
      "slug": "caselle-landi",
      "name": "Caselle Landi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5d3296c9": [{
      "hkey": "8aed549c",
      "slug": "caselle-landi",
      "name": "Caselle Landi",
      "primary": true,
      "skipSearch": false
    }],
    "mezzanone": [{
      "hkey": "8aed549c",
      "slug": "caselle-landi",
      "name": "Caselle Landi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "da953803": [{
      "hkey": "a77a3ea1",
      "slug": "piardello",
      "name": "Piardello",
      "primary": true,
      "skipSearch": false
    }],
    "pierdello": [{
      "hkey": "a77a3ea1",
      "slug": "piardello",
      "name": "Piardello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "67637218": [{
      "hkey": "8aed549c",
      "slug": "caselle-landi",
      "name": "Caselle Landi",
      "primary": true,
      "skipSearch": false
    }],
    "punte-alte": [{
      "hkey": "8aed549c",
      "slug": "caselle-landi",
      "name": "Caselle Landi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4a7ea555": [{
      "hkey": "8aed549c",
      "slug": "caselle-landi",
      "name": "Caselle Landi",
      "primary": true,
      "skipSearch": false
    }],
    "punte-basse": [{
      "hkey": "8aed549c",
      "slug": "caselle-landi",
      "name": "Caselle Landi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b649aca": [{
      "hkey": "8aed549c",
      "slug": "caselle-landi",
      "name": "Caselle Landi",
      "primary": true,
      "skipSearch": false
    }],
    "vallazza": [{
      "hkey": "8aed549c",
      "slug": "caselle-landi",
      "name": "Caselle Landi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4ef1fd01": [{
      "hkey": "2a401a9c",
      "slug": "gerrone-isola",
      "name": "Gerrone-Isola",
      "primary": true,
      "skipSearch": false
    }],
    "gerrone": [{
      "hkey": "2a401a9c",
      "slug": "gerrone-isola",
      "name": "Gerrone-Isola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "61f03b87": [{
      "hkey": "2a401a9c",
      "slug": "gerrone-isola",
      "name": "Gerrone-Isola",
      "primary": true,
      "skipSearch": false
    }],
    "isola": [{
      "hkey": "2a401a9c",
      "slug": "gerrone-isola",
      "name": "Gerrone-Isola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caselle-landi"
    }]
  }
};
exports["default"] = _default;